import type { WithoutDataType } from '@docue/builder/types'

import { BUILDER_SESSION } from '~/types'

import type { Options } from '../useInternalApi'

import { useInternalApi } from '../useInternalApi'
import { useFetchSession } from '../session/useFetchSession'

export type BuilderAuthData =
  App.Http.InternalApi.BuilderSession.Data.SessionAuthenticateData

export type BuilderSessionData =
  App.Http.InternalApi.BuilderSession.Data.SessionData

export type AuthenticateBuilderSessionPayload =
  WithoutDataType<App.Http.InternalApi.BuilderSession.Payload.SessionAuthenticatePayload>

export const useFetchBuilderSession = () => {
  const { post, getUrl } = useInternalApi()
  const { authenticate, getCurrent } = useFetchSession<BuilderAuthData, BuilderSessionData, AuthenticateBuilderSessionPayload>(BUILDER_SESSION)

  const finalize = ({
    options = {},
  }: {
    options?: Options
  }) => post<BuilderSessionData>({
    url: getUrl(BUILDER_SESSION, 'sessions/current/contract/finalize'),
    accessType: BUILDER_SESSION,
    options,
  }).then(res => res.data)

  const refreshParticipantToken = ({
    options = {},
  }: {
    options?: Options
  }) =>
    post<BuilderSessionData>({
      url: getUrl(BUILDER_SESSION, 'sessions/current/refresh-participant-token'),
      accessType: BUILDER_SESSION,
      options,
    }).then(res => res.data)

  return {
    authenticate,
    getCurrent,
    finalize,
    refreshParticipantToken,
  }
}
